import qs from 'query-string';
import React, { Component } from 'react';
import { Table, Input, message, Modal, Tree, Button } from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { backendErrorTip } from '../../../../utils';
import columns from './columns';
import xfetch from '../../../../xfetch';
import UpdateForm from './UpdateForm';
import s from './style.css';

const { TreeNode } = Tree;
const { Search } = Input;

@withStyles(s)
export default class Structure extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
    };
    this.treeApi = `${window.G.backendApi}/profiles/organization/tree/`;
    this.baseApi = `${window.G.backendApi}/profiles/organization/`;
  }
  state = {
    data: {
      results: [],
    },
    item: {},
    nodes: {},
    loading: true,
    modals: {
      updateForm: { title: '', visible: false },
    },
    activeNode: '',
    addModal: true,
  };
  componentDidMount() {
    this.queryTree();
  }
  onTableChange = pagination => {
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  setModals({ key, title, item = {}, visible }, addModal = true) {
    this.setState({
      modals: {
        [key]: {
          ...this.state.modals[key],
          title,
          visible,
        },
      },
      item,
      addModal,
    });
  }
  selectTree = keys => {
    this.setState({
      activeNode: keys[0],
    });
    this.q.parent_org = keys[0] === 'ROOT' ? '' : keys[0];
    this.q.page = 1;
    this.query();
  };
  queryTree = async () => {
    const { error, result } = await xfetch(this.treeApi);
    this.setState({
      loading: false,
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      nodes: { ROOT: { name: '组织架构', id: 'ROOT', children: result.tree } },
    });
    this.setState(
      {
        activeNode: this.state.activeNode || 'ROOT',
      },
      this.query,
    );
    this.query(result);
  };
  query = async () => {
    const api = `${this.baseApi}?${qs.stringify(this.q)}`;
    const { error, result } = await xfetch(api);
    this.setState({
      loading: false,
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      data: result,
    });
  };
  deleteItem = async id => {
    await xfetch(`${this.baseApi}${id}/`, {
      method: 'DELETE',
    });
    this.query();
    this.queryTree();
  };
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  updateItem = () => {
    let title;
    const { item, addModal } = this.state;
    const { id } = item;

    this.updateForm.validateFields((err, values) => {
      if (err) {
        return;
      }

      if (addModal) {
        title = '添加子机构';
        xfetch(this.baseApi, {
          body: values,
          method: 'POST',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('添加成功');
          this.queryTree();
          this.query();
        });
      } else {
        title = '编辑机构';
        xfetch(`${this.baseApi}${id}/`, {
          body: values,
          method: 'PATCH',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('编辑成功');
          this.queryTree();
          this.query();
        });
      }
    });
  };
  triggerStatus = async (id, status) => {
    const nextStatus = status === 'on' ? 'off' : 'on';
    const { error } = await xfetch(`${this.baseApi}${id}/`, {
      body: {
        status: nextStatus,
      },
      method: 'PATCH',
    });
    if (!error) {
      this.setState({
        data: {
          ...this.state.data,
          results: this.state.data.results.map(
            x =>
              x.id === id
                ? {
                    ...x,
                    status: nextStatus,
                  }
                : x,
          ),
        },
      });
    }
  };
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            key={item.id}
            value={item.id}
            dataRef={item}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          {...item}
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      item,
      modals: { updateForm },
      nodes,
      activeNode,
    } = this.state;
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };
    const orgTreeNodes = this.renderTreeNodes(nodes);
    return (
      <div className={s.wrap}>
        <div className={s.row} type="flex">
          <div span={6} className={s.col}>
            {Object.keys(nodes).length ? (
              <Tree
                showLine
                defaultExpandAll
                selectedKeys={[activeNode]}
                onSelect={this.selectTree}
              >
                {orgTreeNodes}
              </Tree>
            ) : null}
          </div>
          <div className={s.coltable}>
            <div className={s.toolbar}>
              <div className={s.toolbarLeft}>
                <Button
                  type="primary"
                  onClick={() => {
                    this.setModals({
                      key: 'updateForm',
                      title: '添加机构',
                      item: {},
                      visible: true,
                    });
                  }}
                >
                  添加机构
                </Button>
              </div>
              <div className={s.toolbarRight}>
                <Search
                  placeholder="输入关键词搜索"
                  onSearch={this.handleSearch}
                  style={{ width: 260 }}
                  enterButton="搜索"
                />
              </div>
            </div>
            <div className={s.table}>
              <Table
                loading={loading}
                dataSource={results}
                columns={columns(this, s)}
                pagination={pagination}
                onChange={this.onTableChange}
              />
            </div>
            <Modal
              title={updateForm.title}
              visible={updateForm.visible}
              width={550}
              destroyOnClose
              maskClosable={false}
              onOk={this.updateItem}
              onCancel={() =>
                this.setModals({
                  key: 'updateForm',
                  title: '',
                  visible: false,
                })
              }
              className={s.updateGroupForm}
            >
              <UpdateForm
                ref={x => {
                  this.updateForm = x;
                }}
                item={item}
                orgTreeNodes={orgTreeNodes}
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
